import Swiper from "swiper/swiper-bundle";

window.addEventListener("DOMContentLoaded", () => {
  const mainSwiperOptions = {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    lazyPreloadPrevNext: 0,
    lazyPreloaderClass: 'swiper-lazy-preloader',
    pagination: {
      el: ".swiper-pagination",
      type: 'bullets',
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    allowSlidePrev: true,
    allowSlideNext: true,
  };

  new Swiper(".mainSwiper", mainSwiperOptions);

  const newsOne = {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: false,

    breakpoints: {
      768: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: false,
      },
    },
  };

  new Swiper(".newsOneSwiper", newsOne);

  const swiperOptions = {
    slidesPerView: 1.2,
    spaceBetween: 8,
    loop: true,
    loopAdditionalSlides: 2,
    breakpoints: {
      768: {
        slidesPerView: 2.2,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 24,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    },
  };

  new Swiper(".discountSwiper", swiperOptions);
  new Swiper(".infoSwiper", swiperOptions);
  new Swiper(".stockSwiper", swiperOptions);
  new Swiper(".newsSwiper", swiperOptions);

  const featSwiperOptions = {
    slidesPerView: 1,
    loop: false,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      1024: {
        pagination: false,
      },
    },
  };

  new Swiper(".featSwiper", featSwiperOptions);
});
